import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./about-card.${locale}.json`));
